module.exports = __webpack_public_path__ + "static/media/STEEL.0c07aafb.png";